import { Heading, Inline, Text, Button, Stack, textVariants, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { X as CloseIcon } from '@phosphor-icons/react';
import { css, cx } from '@eti/styles';
import { SEAT_MAP_PERSIST_DIALOG_ID, STEP_INDICATOR_HEIGHT } from '../constants/modal';
import SeatMapTravelersMobileTabs from './travelers/SeatMapTravelersMobileTabs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const seatmapHeaderStyles = {
  base: css`
    background: ${vars.colors.surface.primary};
    box-shadow: 0 2px 4px 0 #0000000d;
    padding: 16px;
    position: relative;
    z-index: 1;
  `,
  sticky: css`
    position: sticky;
    top: calc(var(--header-offset, 0) + ${STEP_INDICATOR_HEIGHT}px);
    transition: top 0.2s ease-in-out;
  `
};
const headerStyles = css`
  justify-content: space-between;
`;
const segmentRowStyles = css`
  align-items: center;
  justify-content: space-between;
`;
const closeButtonStyles = css`
  background-color: ${vars.colors.surface.primary};
  border-width: 0;
  height: 25px;
  margin-bottom: auto;
  padding: 0;
  width: 25px;
`;
const SeatMapHeader = ({
  activeSeatAssignments,
  activeSegment,
  activeTraveler,
  currentSegmentData,
  currentSegmentIndex,
  from,
  handleCloseButton,
  isMobileSelectionHidden,
  isPersistDialogOpen,
  isRyanairInTrip,
  isSegmentCountHidden,
  isUpperPartHidden,
  onChange,
  onRemoveSeat,
  seatTravelers,
  setTravelerButtonWithRemoveLink,
  shouldRenderInline,
  to,
  totalSegmentsCount,
  travelerButtonWithRemoveLink
}) => {
  const {
    t
  } = useTranslation();
  const closeButtonLabel = t('ScreenReader.CloseButtonDialog.AriaLabel.Text');
  const detailsDescriptionLabel = currentSegmentData ? t('Seating.Segments.Details.Description', currentSegmentIndex, totalSegmentsCount, currentSegmentData.from.iata, currentSegmentData.to.iata) : undefined;
  const headerLabel = t('Product.SeatMap.Header.Label');
  const toLabel = String(t('ScreenReader.To.AriaLabel.Text')).toLowerCase();
  const showSegmentCount = detailsDescriptionLabel && currentSegmentIndex > 0 && totalSegmentsCount > 0;
  return /*#__PURE__*/_jsxs(Stack, {
    as: "header",
    className: cx(seatmapHeaderStyles.base, {
      [seatmapHeaderStyles.sticky]: shouldRenderInline
    }),
    spacing: 16,
    children: [!isUpperPartHidden && /*#__PURE__*/_jsxs(Inline, {
      className: headerStyles,
      "data-testid": "seatMap-header",
      children: [/*#__PURE__*/_jsx(Heading, {
        "data-testid": "seatMap-heading",
        level: 2,
        children: headerLabel
      }), /*#__PURE__*/_jsx(Button, {
        "aria-controls": SEAT_MAP_PERSIST_DIALOG_ID,
        "aria-expanded": isPersistDialogOpen,
        "aria-haspopup": "dialog",
        "aria-label": closeButtonLabel,
        className: closeButtonStyles,
        "data-testid": "seatMap-closeIcon-button",
        onClick: handleCloseButton,
        type: "button",
        children: /*#__PURE__*/_jsx(CloseIcon, {
          "aria-hidden": "true",
          size: 25
        })
      })]
    }), /*#__PURE__*/_jsxs(Inline, {
      className: segmentRowStyles,
      children: [from && to && /*#__PURE__*/_jsxs(Text, {
        "aria-label": `${from} ${toLabel} ${to}`,
        "data-testid": "seatMap-segment-description",
        variant: textVariants._16_BOLD,
        children: [from, " \u2013 ", to]
      }), !isSegmentCountHidden && showSegmentCount && /*#__PURE__*/_jsx(Text, {
        "data-testid": "seatMap-segments-text",
        variant: textVariants._14,
        children: detailsDescriptionLabel
      })]
    }), !isMobileSelectionHidden && /*#__PURE__*/_jsx(SeatMapTravelersMobileTabs, {
      activeSeatAssignments: activeSeatAssignments,
      activeSegment: activeSegment,
      activeTraveler: activeTraveler,
      isRyanairInTrip: isRyanairInTrip,
      onChange: onChange,
      onRemoveSeat: onRemoveSeat,
      seatTravelers: seatTravelers,
      setTravelerButtonWithRemoveLink: setTravelerButtonWithRemoveLink,
      travelerButtonWithRemoveLink: travelerButtonWithRemoveLink
    })]
  });
};
export default SeatMapHeader;
//# sourceMappingURL=SeatMapHeader.js.map